import { z } from 'zod';
/** Statut d'un fichier d'export — `03` §2 (`exportFiles.status`) et §3. */
export const EXPORT_FILE_STATUSES = [
    'generated',
    'queued',
    'shadow',
    'uploading',
    'sent',
    'error',
];
export const exportFileStatusSchema = z.enum(EXPORT_FILE_STATUSES);
export const EXPORT_FILE_STATUS = {
    generated: {
        code: 'generated',
        label: 'Généré',
        tone: 'blue',
        description: 'Produit, en attente d’envoi FTP.',
    },
    queued: {
        code: 'queued',
        label: 'En file (maintenance)',
        tone: 'blue',
        description: 'Envoi différé par le mode maintenance.',
    },
    shadow: {
        code: 'shadow',
        label: 'Généré (shadow)',
        tone: 'blue',
        description: 'Non envoyé car la boutique est en mode shadow.',
    },
    uploading: { code: 'uploading', label: 'Envoi en cours', tone: 'blue' },
    sent: { code: 'sent', label: 'Envoyé', tone: 'green' },
    error: {
        code: 'error',
        label: 'En erreur',
        tone: 'red',
        description: 'Upload en échec après épuisement des tentatives.',
    },
};
/** Origine d'un fichier d'export — `03` §2 (`exportFiles.source`). */
export const EXPORT_FILE_SOURCES = ['order', 'invoice', 'manual', 'v1'];
export const exportFileSourceSchema = z.enum(EXPORT_FILE_SOURCES);
export const EXPORT_FILE_SOURCE = {
    order: { code: 'order', label: 'Commande Shopify', tone: 'blue' },
    invoice: { code: 'invoice', label: 'Facture Pennylane', tone: 'blue' },
    manual: { code: 'manual', label: 'Upload manuel', tone: 'gray' },
    // Fichier réellement déposé par la v1, repris par `import-history` : il
    // porte en général plusieurs commandes.
    v1: { code: 'v1', label: 'Envoi v1', tone: 'gray' },
};
/**
 * Compte FTP Martelet : `215` pour les commandes Shopify, `216` pour les
 * factures Pennylane (`01` §3, `01` §6.3).
 */
export const FTP_ACCOUNTS = ['215', '216'];
export const ftpAccountSchema = z.enum(FTP_ACCOUNTS);
export const FTP_ACCOUNT = {
    '215': { code: '215', label: '215 — Commandes Shopify', tone: 'blue' },
    '216': { code: '216', label: '216 — Factures Pennylane (B2B)', tone: 'blue' },
};
//# sourceMappingURL=file.js.map